import { MemberContactsListVendor } from '../../../components/Member/Contacts';
import { usePageTitle } from '../../../hooks';

export function MemberContacts() {
  usePageTitle('member:contact.title');
  return <MemberContactsListVendor />;
}
